var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M18.483 9.195l-3.679-3.679a2.604 2.604 0 0 1 1.664-.596A2.605 2.605 0 0 1 19.08 7.53c0 .618-.21 1.197-.596 1.664zM9.486 18.21l-1.503-1.504 8.356-8.356 1.503 1.503-8.356 8.357zm4.66-12.05L15.685 7.7l-8.356 8.356-1.537-1.537 8.356-8.357zm4.818-1.124a3.528 3.528 0 0 0-4.995 0L4.812 14.19a.457.457 0 0 0-.13.263l-.678 5.025c-.02.143.031.287.13.385a.466.466 0 0 0 .324.137c.02 0 .04 0 .061-.003l3.027-.41a.46.46 0 1 0-.122-.913L4.996 19l.474-3.505 3.69 3.69a.452.452 0 0 0 .648 0l9.156-9.155A3.51 3.51 0 0 0 20 7.53c0-.944-.368-1.83-1.036-2.495z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#467A3C",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.c9de5cdd3aed732f851d71625e128e28.svg";
export { ForwardRef as ReactComponent };